/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCohere = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M5.44 14.693c1.893 0 3.413 1.547 3.44 3.413v.454A3.449 3.449 0 0 1 5.44 22C3.547 22 2 20.454 2 18.587v-.453a3.45 3.45 0 0 1 3.44-3.44zm10.133-1.627C18.64 11.813 22 14.054 22 17.36c0 2.56-2.08 4.64-4.64 4.64h-3.28c-2.187 0-3.974-1.787-3.974-4 0-1.6.96-3.066 2.454-3.68zM17.547 2a4.137 4.137 0 0 1 4.133 4.134c0 1.653-.747 2.88-2.48 3.812-2.48 1.334-5.893 2.614-7.627 3.334-1.493.613-2.56.64-3.093.64C4.507 13.92 2 11.226 2 7.946A5.952 5.952 0 0 1 7.946 2z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgCohere as Cohere };
